import React from 'react';
import { Box, Typography, Tooltip } from '@mui/material';

const Heatmap = ({ data, xLabels, yLabels, title }) => {
  // Find min and max values for color scaling
  let minValue = Infinity;
  let maxValue = -Infinity;
  
  data.forEach(row => {
    xLabels.forEach(label => {
      const value = row[label];
      if (typeof value === 'number') {
        minValue = Math.min(minValue, value);
        maxValue = Math.max(maxValue, value);
      }
    });
  });
  
  // Function to get color based on value
  const getColor = (value) => {
    if (typeof value !== 'number') return '#f5f5f5';
    if (value === 0) return '#f5f5f5';
    
    const normalized = (value - minValue) / (maxValue - minValue);
    const intensity = Math.floor(normalized * 255);
    return `rgb(${255 - intensity}, ${255 - intensity * 0.5}, ${255})`;
  };
  
  return (
    <Box>
      {title && (
        <Typography variant="h6" gutterBottom>
          {title}
        </Typography>
      )}
      <Box sx={{ overflowX: 'auto' }}>
        <table style={{ borderCollapse: 'collapse', width: '100%', minWidth: '600px' }}>
          <thead>
            <tr>
              <th style={{ 
                padding: '8px', 
                border: '1px solid #ddd',
                backgroundColor: '#f5f5f5',
                position: 'sticky',
                left: 0,
                zIndex: 1
              }}>
                Platform
              </th>
              {xLabels.map((label) => (
                <th key={label} style={{ 
                  padding: '8px', 
                  border: '1px solid #ddd',
                  backgroundColor: '#f5f5f5',
                  minWidth: '80px'
                }}>
                  {label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {data.map((row) => (
              <tr key={row.platform}>
                <td style={{ 
                  padding: '8px', 
                  border: '1px solid #ddd',
                  fontWeight: 'bold',
                  backgroundColor: '#f5f5f5',
                  position: 'sticky',
                  left: 0
                }}>
                  {row.platform}
                </td>
                {xLabels.map((label) => {
                  const value = row[label];
                  return (
                    <Tooltip
                      key={label}
                      title={`${row.platform} - ${label}: ${typeof value === 'number' ? value.toFixed(1) : 'N/A'} lines`}
                      placement="top"
                    >
                      <td style={{ 
                        padding: '8px', 
                        border: '1px solid #ddd',
                        backgroundColor: getColor(value),
                        textAlign: 'center',
                        cursor: 'pointer'
                      }}>
                        {typeof value === 'number' ? value.toFixed(0) : '-'}
                      </td>
                    </Tooltip>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
      <Box sx={{ mt: 2, display: 'flex', alignItems: 'center', gap: 2 }}>
        <Typography variant="body2" color="textSecondary">
          Color intensity indicates average number of lines
        </Typography>
        <Box sx={{ display: 'flex', gap: 0.5 }}>
          <Box sx={{ width: 20, height: 20, backgroundColor: '#f5f5f5', border: '1px solid #ddd' }} />
          <Typography variant="body2">Low</Typography>
          <Box sx={{ width: 20, height: 20, backgroundColor: 'rgb(200, 220, 255)', border: '1px solid #ddd' }} />
          <Box sx={{ width: 20, height: 20, backgroundColor: 'rgb(150, 185, 255)', border: '1px solid #ddd' }} />
          <Box sx={{ width: 20, height: 20, backgroundColor: 'rgb(100, 150, 255)', border: '1px solid #ddd' }} />
          <Box sx={{ width: 20, height: 20, backgroundColor: 'rgb(50, 115, 255)', border: '1px solid #ddd' }} />
          <Box sx={{ width: 20, height: 20, backgroundColor: 'rgb(0, 80, 255)', border: '1px solid #ddd' }} />
          <Typography variant="body2">High</Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default Heatmap;